<template>
  <div
    v-if="contact"
    :style="{
    'font-size': '14px',
    'line-height': '16px',
  }"
    class="my-1"
  >
    <v-icon small>mdi-account</v-icon>
    <country-flag
      v-if="contact.use_ukrainian"
      style="vertical-align: sub"
      :size="14"/>
    <country-flag
      v-if="contact.use_english"
      image="img/flags/uk.svg"
      style="vertical-align: sub"
      :size="14"/>
    <viber
      v-if="contact.is_viber"
      style="vertical-align: sub"
      :size="14"/>
    <router-link :to="{ name: 'contacts.show', params: { uuid: contact.uuid || '0000' }}">
      {{contact.name}}
    </router-link>
    <span
      v-if="contact.phone_note"
    >
        ({{contact.phone_note}})&nbsp;
      </span>
    <a :href="'tel:'+formatPhoneForLink(contact.phone)">
      {{contact.phone}}
    </a>
    <span
      v-if="contact.phone2"
    >&nbsp;|&nbsp;</span>
    <span
      v-if="contact.phone2_note"
    >
        ({{contact.phone2_note}})&nbsp;
      </span>
    <a
      v-if="contact.phone2"
      :href="'tel:'+formatPhoneForLink(contact.phone2)">
      {{contact.phone2}}
    </a>
  </div>
</template>

<script>
import { formatPhoneForLink } from '../../utils';
import countryFlag from '../icons/countryFlag.vue';
import viber from '../icons/viber.vue';

export default {
  name: 'ContactLine',
  components: {
    countryFlag,
    viber,
  },
  props: {
    contact: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      formatPhoneForLink,
    };
  },
};
</script>

<style scoped>

</style>
